<template>
  <b-card title="Validação Extrato">
    <b-col md="12">
      <b-row class="align-items-center">
        <b-form-select
          v-model="selectedEC"
          :options="dropdownOptionsExtract"
          placeholder="Escolha um EC"
          class="mb-2"
        />
      </b-row>
    </b-col>
    <div v-if="loading" class="text-center my-4">
      <b-spinner label="Carregando..." variant="primary" />
    </div>
    <b-table
      v-else
      :items="filteredItems"
      :fields="formattedFields"
      small
      bordered
      responsive
      :per-page="15"
      :current-page="currentPage"
      @row-clicked="openModal"
    ></b-table>
    <b-pagination
      v-model="currentPage"
      :total-rows="items.length"
      :per-page="15"
      align="center"
      size="sm"
      class="my-0"
    />

    <b-modal
      id="details-modal"
      ref="detailsModal"
      title="Detalhes do EC"
      hide-footer
      size="lg"
    >
      <div v-if="selectedECData">
        <b-row class="justify-content-between px-5">
          <p><strong>EC:</strong> {{ selectedRow.ec }}</p>
          <p><strong>Nome:</strong> {{ selectedRow.nome }}</p>
          <p><strong>Diferença:</strong>{{ formatCurrency(selectedRow.diferença) }}</p>
        </b-row>

        <hr />
        <div v-if="selectedECData && selectedECData.length">
          <div
            v-for="(extract, index) in selectedECData"
            :key="index"
            class="border rounded border-dark border-2 pt-1 pl-3 mb-2"
          >
            <b-row>
              <b-col cols="4">
                <p><strong>Data:</strong> {{ formatDate(extract.date) }}</p>
                <p><strong>Tipo:</strong> {{ extract.type }}</p>
                 <p><strong>Disponível:</strong>{{ formatCurrency(extract.available) }}</p>
              </b-col>

              <b-col cols="4">
                <p><strong>A Receber:</strong> {{ formatCurrency(extract.waitingFunds) }}</p>
                <p> <strong>Valor Líquido:</strong>{{ formatCurrency(extract.netAmount) }}</p>
                <p><strong>Valor de recebimento:</strong> {{ formatCurrency(extract.amount) }}</p>
              </b-col>

              <b-col cols="4">
                <p> <strong>Saldo Anterior:</strong> {{ formatCurrency(extract.balanceOldAmount) }}  </p>
                <p> <strong>Saldo Atual:</strong> {{ formatCurrency(extract.balanceAmount) }} </p>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </b-modal>
  </b-card>
</template>

<script>
import { DateTime } from "luxon";

import {
  BModal,
  BCard,
  BForm,
  BRow,
  BCol,
  BTable,
  BPagination,
  BFormSelect,
  BSpinner,
} from "bootstrap-vue";

export default {
  components: {
    BCard,
    BForm,
    BRow,
    BCol,
    BModal,
    BTable,
    BPagination,
    BFormSelect,
    BSpinner,
  },
  props: {
    items: Array,
    dropdownOptionsExtract: Array,
    selectedEC: String,
    formattedFields: Array,
    loading: Boolean,
    rawExtractData: {
      type: Array,
      default: () => ({}),
    },
  },
  data() {
    return {
      currentPage: 1,
      selectedRow: null,
      selectedECData: null,
    };
  },
  computed: {
    filteredItems() {
      if (this.selectedEC) {
        return this.items.filter((item) => item.ec === this.selectedEC);
      }
      return this.items;
    },
  },

  methods: {
    openModal(row) {
      const ecKey = String(row.ec);
      let ecData = null;

      Object.values(this.rawExtractData).forEach((entry) => {
        const keys = Object.keys(entry);
        keys.forEach((key) => {
          if (key === ecKey) {
            ecData = entry[key];
          }
        });
      });

      if (ecData) {
        this.selectedECData = ecData.data;
      } else {
        this.selectedECData = null;
      }

      this.selectedRow = row;
      this.$refs.detailsModal.show();
    },

    formatCurrency(value) {
      return Number(value).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
      });
    },
    formatDate(date) {
      if (!date) return "";
      const splitDate = date.split("T")[0];
      return DateTime.fromISO(splitDate).toFormat("dd/MM/yyyy");
    },
  },
};
</script>
